import React from 'react';
// Client/trusted-leaders marquee hidden pending logo approval: restore LogoMarquee + COMPANY_LOGOS when cleared.
// import LogoMarquee from '../shared/LogoMarquee';
// import { COMPANY_LOGOS } from '../../../content/logoSlideshowData';

const tools = [
  'Google Analytics',
  'Amazon AWS',
  'Microsoft Azure',
  'Microsoft Fabric',
  'Fabric Data Factory',
  'Apache Hadoop',
  'Databricks',
  'Apache Spark',
  'Freshdesk',
  'HubSpot',
  'SAP',
  'Google Cloud',
  'IBM',
  'Mailchimp',
  'Kissmetrics',
  'Oracle',
  'HRIS',
];

export default function LogoSlideshow() {
  const repeatedTools = [...tools, ...tools, ...tools];

  return (
    <div
      className="w-full max-w-full border-b border-gray-200 pt-3 pb-5"
      style={{ background: 'rgba(240,250,255,0.6)' }}
    >
      {/* Temporary: client logo row hidden while awaiting approval
      <LogoMarquee
        label="Trusted by industry leaders"
        logos={COMPANY_LOGOS}
        direction="left"
        duration={55}
      />
      */}
      <div className="pt-1">
        <p className="mb-3 px-6 text-xs font-semibold uppercase tracking-widest text-gray-400">
          Supported Applications
        </p>
        <div className="flex max-w-full flex-wrap justify-center gap-2 px-4 sm:hidden">
          {tools.map((name) => (
            <span
              key={name}
              className="rounded-full px-4 py-1.5 text-xs font-medium text-brand-600"
              style={{ background: 'rgba(255,255,255,0.45)', border: '1px solid rgba(0,180,254,0.25)' }}
            >
              {name}
            </span>
          ))}
        </div>
        <div className="relative hidden max-w-full overflow-hidden sm:block">
          <div
            className="pointer-events-none absolute inset-0 z-10"
            style={{
              background:
                'linear-gradient(to right, rgba(240,250,255,0.85) 0%, rgba(240,250,255,0.3) 20%, rgba(240,250,255,0.3) 80%, rgba(240,250,255,0.85) 100%)',
            }}
            aria-hidden="true"
          />
          <div
            className="supported-apps-marquee flex gap-3"
            style={{ width: 'fit-content', animation: 'marqueeRight 45s linear infinite' }}
          >
            {repeatedTools.map((name, i) => (
              <span
                key={i}
                className="flex-shrink-0 whitespace-nowrap rounded-full px-4 py-1.5 text-xs font-medium text-brand-600"
                style={{ background: 'rgba(255,255,255,0.45)', border: '1px solid rgba(0,180,254,0.25)' }}
              >
                {name}
              </span>
            ))}
          </div>
        </div>
        <style>{`
          @keyframes marqueeRight {
            0%   { transform: translateX(calc(-100% / 3)); }
            100% { transform: translateX(0); }
          }
          @media (prefers-reduced-motion: reduce) {
            .supported-apps-marquee { animation: none !important; }
          }
        `}</style>
      </div>
    </div>
  );
}
